import { Layout, Avatar, Dropdown, Space } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MenuOutlined,
  UserOutlined,
  LogoutOutlined,
  DownOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher, useAppStore, useAuthStore, useResponsive } from '@/shared';
import { queryClient } from '@/shared/api';
import styles from './Header.module.css';

const { Header: AntHeader } = Layout;

export const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobile, isTablet } = useResponsive();
  const sidebarCollapsed = useAppStore((state) => state.sidebarCollapsed);
  const toggleSidebar = useAppStore((state) => state.toggleSidebar);
  const setMobileSidebarOpen = useAppStore((state) => state.setMobileSidebarOpen);
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);

  const handleToggle = () => {
    if (isMobile) {
      setMobileSidebarOpen(true);
    } else {
      toggleSidebar();
    }
  };

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: t('header.profile'),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('header.logout'),
      danger: true,
    },
  ];

  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'logout') {
      queryClient.clear();
      logout();
    } else if (key === 'profile') {
      navigate('/profile');
    }
  };

  const renderMenuToggleIcon = () => {
    if (isMobile) return <MenuOutlined className={styles.menuIcon} />;
    if (sidebarCollapsed) return <MenuUnfoldOutlined className={styles.menuIcon} />;
    return <MenuFoldOutlined className={styles.menuIcon} />;
  };

  return (
    <AntHeader className={styles.header}>
      <div className={styles.leftContent}>
        <button className={styles.menuButton} onClick={handleToggle}>
          {renderMenuToggleIcon()}
        </button>
      </div>

      <div className={styles.rightContent}>
        <LanguageSwitcher variant='dark' />

        <Dropdown menu={{ items: userMenuItems, onClick: handleMenuClick }} placement='bottomRight' trigger={['click']}>
          <div className={styles.accountMenu}>
            <Avatar icon={<UserOutlined />} size={isMobile ? 36 : 44} style={{ border: 'none' }} />
            {!isMobile && !isTablet && (
              <Space size={8} align='center'>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className={styles.userName}>
                    {user?.full_name || user?.email || t('header.administrator')}
                  </span>
                  {user?.role_name ? <span className={styles.userRole}>{user.role_name}</span> : null}
                </div>
                <DownOutlined className={styles.dropdownIcon} />
              </Space>
            )}
          </div>
        </Dropdown>
      </div>
    </AntHeader>
  );
};
